import { MainColumns } from '../../../../../../../components/TableGrid';

export const columnsCompany: MainColumns[] = [
  { field: 'name', minWidth: 250 },
  { field: 'officialValidFrom' },
  { field: 'officialValidTo' },
];

export const columnsStatus: MainColumns[] = [
  { field: 'name', minWidth: 250 },
  { field: 'officialValidFrom' },
  { field: 'officialValidTo' },
];

export const columnsLegalForm: MainColumns[] = [
  { field: 'name', minWidth: 250 },
  { field: 'officialValidFrom' },
  { field: 'officialValidTo' },
];

export const columnsAddress: MainColumns[] = [
  { field: 'name', minWidth: 250 },
  { field: 'officialValidFrom' },
  { field: 'officialValidTo' },
];

export interface AddressHistory {
  name: string;
  officialValidFrom?: string;
  officialValidTo?: string;
}

export const columnsAttribute: MainColumns[] = [
  { field: 'name', minWidth: 250 },
  { field: 'officialValidFrom' },
  { field: 'officialValidTo' },
];
